import api from 'poly-eshop4/eshop/ui/js/container';
import { load } from 'poly-eshop4/eshop/ui/js/util';

$(document).on('change', '[data-update-cart-position-dimension-select]', function() {
  const form = $(this).closest('form');
  const pospk = form.attr('data-pk');
  $(`#mutable_dimension_quantity_${pospk}`).val(this.value);
});

function checkqtyt(n) {
  return n % 1 === 0;
}

$(document).on('change', '[data-update-cart-position-dimension]', function() {
  const pospk = $(this).attr('data-pk');
  $(`#container-item-ready_${pospk}`).hide();
  const select = $(`#dimension-quantity-${pospk}`);
  const dimensionQuantity = select.val();
  const mutable = $('option:selected', select).attr('data-mutable');
  const dimensionunit = $('option:selected', select).attr('data-dimension_unit');
  const serialnumber = $('option:selected', select).attr('data-serial_number');
  const quantityInput = $(`#quantity-${pospk}`);
  const qty = quantityInput.val();
  const dqty = $(`#mutable_dimension_quantity_${pospk}`).val();
  const dqtymin = $(`#mutable_dimension_quantity_${pospk}`).attr('min');
  const dqtyfix = $(`#mutable_dimension_quantity_${pospk}`).attr('fix');
  $(`#warning_${pospk}`).addClass('hide');
  $(`#warning_aumng_${pospk}`).addClass('hide');

  $(`#container-item__qty-dimension_${pospk}`).hide();
  $(`#mutable_dimension_quantity_${pospk}`).attr('name', '');
  $(`#dimension_quantity_${pospk}`).attr('name', 'dimension_quantity');
  $(`#dimension_quantity_${pospk}`).val(dimensionQuantity);
  quantityInput.removeAttr('disabled');
  $(`#dimension_unit_${pospk}`).val(dimensionunit);
  $(`#dimension_is_mutable_${pospk}`).val(mutable);
  $(`#serial_number_${pospk}`).val(serialnumber);

  if (mutable === '1') {
    $(`#container-item__qty-dimension_${pospk}`).show();
    $(`#dimension_quantity_${pospk}`).attr('name', '');
    $(`#mutable_dimension_quantity_${pospk}`).attr('name', 'dimension_quantity');
  }

  if (serialnumber) {
    quantityInput.attr('disabled', 'disabled');
    quantityInput.val(1);
  }

  let cartvalid = true;
  if (!checkqtyt(qty)) {
    cartvalid = false;
  } else if (!checkqtyt(dqty)) {
    cartvalid = false;
  } else if (parseFloat(dqty) < parseFloat(dqtymin)) {
    if (parseFloat(dqtyfix) > 0) {
      const checkqty = qty * dqty;
      if (parseFloat(checkqty) < parseFloat(dqtymin)) {
        cartvalid = false;
      }
    } else {
      cartvalid = false;
    }
  }

  if (cartvalid) {
    const store = 'cart';
    const $form = $(this).closest('form');
    const data = $form.serializeArray();
    if ($(`[data-bind-html="${store}:html"]`).length) {
      data.push({ name: 'render', value: 1 });
      data.push({ name: 'calculate', value: 1 });
    }
    quantityInput.get(0).defaultValue = quantityInput.val();
    load(
      $form,
      $.stores[store].post($form.attr('action'), data).then((response) => {
        quantityInput.val(parseFloat(response.position.quantity));
      }),
      { errorClass: 'error' },
    );
  // api.updateQuantity(quantityInput, 'cart');
  } else {
    if (parseFloat(dqty) < parseFloat(dqtymin)) {
      $(`#warning_${pospk}`).addClass('hide');
      $(`#warning_aumng_${pospk}`).removeClass('hide');
    } else {
      $(`#warning_${pospk}`).removeClass('hide');
      $(`#warning_aumng_${pospk}`).addClass('hide');
    }
    console.log('FEHLER');
  }
});

$(document).on('submit', '[data-add-cart-position-label]', function(event) {
  event.preventDefault();
  api.addPosition($(this), 'cart');
});
